export default __webpack_public_path__ + "static/media/cat3b.7597b43e.jpg";